import { getAxiosInstance } from "../../api";

export const bulkUploadCertificates = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/old-certificates/bulk-upload`, body);
    return res;
  } catch (error) {
    return error.response?.data;
  }
};
